import React from "react";

import {
  Button,
  ButtonTypes,
  Card,
  ExternalLinkIcon,
  Text,
  TextColors,
  TextTypes,
} from "@/component-library";
import { ICON_SIZES, ICON_TYPES } from "@/constants/icons";

const payBillUrl =
  "https://www.medentlink.com/openedge/guestpay/index.php?practice_id=AE5sjG3S&auth_key=15147750-8015-11eb-9439-0242ac130002";

const PayBillSection = () => {
  return (
    <Card className="CardSection">
      <Text color={TextColors.black} type={TextTypes.heading2}>
        Online Bill Pay
      </Text>

      <div className="PayBillSection--content">
        <Text className="PayBillSection--text" color={TextColors.grey} type={TextTypes.paragraph}>
          Pay your bill online using the information from your statement.
        </Text>

        <Button
          buttonType={ButtonTypes.primaryV2}
          className="PayBillSection--button"
          onClick={() => {
            window.open(payBillUrl, "_blank");
          }}
        >
          Pay Bill
          <ExternalLinkIcon
            className="PayBillSection--link-icon"
            iconSize={ICON_SIZES.SMALL}
            iconType={ICON_TYPES.OUTLINE}
          />
        </Button>
      </div>
    </Card>
  );
};

export default PayBillSection;
